import { ResourceLimits, UserPermissionType, UserRoleType } from "@apiserver-rest/ponder-auth-client-base"

export class RoleAndPermissions {
    public expires!: Date;

    public constructor(public role?: UserRoleType,  public permissions?: UserPermissionType[], public limits?: ResourceLimits, expires?: Date) {
        if (expires) {
            this.expires = new Date(expires);
        } else {
            this.expires = new Date();
            this.expires = new Date(this.expires.getTime() + (10 * 60 * 1000));
        }
    }

    public isExpired(): boolean {
        var now = (new Date()).getTime();
        var exp = this.expires.getTime();
        
        return (now > exp);
    }

    public hasRole(role: UserRoleType): boolean {
        return !this.isExpired() && (this.role && (this.role == role)) ? true : false;
    }

    public hasPermission(permission: UserPermissionType): boolean {
        return !this.isExpired() && (this.permissions && (this.permissions?.indexOf(permission) >= 0)) ? true : false;
    }

    public hasElevatedRole(): boolean {
        if (!this.role) {
            return false;
        }

        switch (this.role) {
            case UserRoleType.UserPlus:
            case UserRoleType.Moderator:
            case UserRoleType.Administrator:
                return true;

            default:
                return false;
        }
    }
};